export const LOAD_BIDDER_DATA_FAIL = 'la/domain/bidderData/LOAD_FAIL';
export const LOAD_BIDDER_DATA_REQUEST = 'la/domain/bidderData/LOAD_REQUEST';
export const LOAD_BIDDER_DATA_SUCCESS = 'la/domain/bidderData/LOAD_SUCCESS';
export const LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';
